export const feacherReducer = (state={translate:{"سایز":["2.00x3.00"]}},action) => {
    switch (action.type) {
        case "GET_FEATURE":
            return {...action.payload};
        default:
            return state;
    }
}